module.exports = __webpack_public_path__ + "img/2_58.af829cb4.png";